export default class Url {
  static Root = '/';

  static CompanyInfo = '/company-info';

  static Onboarding = '/onboarding';
  static OnboardingAuthority = '/onboarding/authority';
  static OnboardingKidsRegister = '/onboarding/kids-register';

  static Login = '/login';
  static LoginPass = '/login/pass';
  static LoginWelcome = '/login/welcome';

  static Home = '/home';
  static HomeChangeKids = '/home/change-kids';
  static HomeSelectKid = '/home/select-kid';
  static HomeMultiIntelligenceIntro = '/home/multi-intelligence-intro';
  static HomeOnkidsAIIntro = '/home/onkids-ai-intro';

  static Report = '/report';
  static ReportDetail = '/report/detail';
  static ReportDetailCommentary = '/report/detail/commentary';

  static History = '/history';
  static HistoryAllVideos = '/history/all-videos';
  static HistoryFavoriteVideos = '/history/favorite-videos';
  static HistoryWatchVideo = '/history/watch-video';
  static HistoryIntelligenceVideos = '/history/intelligence-videos';

  static Education = '/education';

  static Community = '/community';
  static CommunityWrite = '/community/write';

  static My = '/my';
  static MyParentProfile = '/my/parent-profile';
  static MyKidsManage = '/my/kids-manage';
  static MyKidProfile = '/my/kid-profile';
  static MyNotice = '/my/notice';
  static MyFrequentQnA = '/my/qna/frequent';
  static MyPrivateQnA = '/my/qna/private';
  static MyUsageGuide = '/my/usage-guide';
  static MyList = '/my/list';
  static MyCompanyInfo = '/my/company-info';
  static KidsRegister = '/register-kids';
  static KidsRegisterUpload = '/register-kids/upload';
  static KidsVideoAnalysis = '/register-kids/video-analysis';
  static KidsAnalysisResult = '/register-kids/analysis-result';
}
